import { Img } from 'react-image';
import { SwiperComponent } from '../shared/SwiperComponent';

const RecruiterSideUsersSwiperComponent = () => {
	const userCards = [
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/user1_f44fa40167.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/user2_aeff719429.png',
		'https://masai-website-images.s3.ap-south-1.amazonaws.com/user3_7af87bb5a1.png',
	];

	return (
		<div className="txl:block hidden isolate relative max-w-[335px] max-h-[323px] overflow-hidden">
			<div className="z-[100] absolute w-full h-full inset-0 [background:linear-gradient(90deg,_#FFF_7.76%,_rgba(255,_255,_255,_0.00)_22.17%,_rgba(255,_255,_255,_0.00)_72.19%,_#FFF_92.54%)]" />
			<SwiperComponent
				options={{
					pagination: false,
					centeredSlides: true,
					slidesPerView: 1.6,
					spaceBetween: 16,
					autoplay: {
						delay: 2500,
					},
					loop: true,
				}}
			>
				{userCards?.map((el, index) => (
					<div className="w-full h-full" key={index}>
						<Img src={el} className="w-full h-full object-contain max-h-[323px]" />
					</div>
				))}
			</SwiperComponent>
		</div>
	);
};

export default RecruiterSideUsersSwiperComponent;
